module.exports = "/_next/static/chromiums/twitter-512x512-products-peppermint-creme-lip-balm-6a1528ce22ce1e414cd8de3a20bd2f3f.jpg";